<template>
  <span>
    <b-card no-body>
      <b-card-header>
        <b-row>
          <b-col md="10">
            <h3>Pesquisar Instituições</h3>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col sm="8">
            <b-form-group label="Nome Instituição e CNPJ:">
              <b-form-input type="text" id="name" v-model="filtros.filter" placeholder="Pesquisa por nome e CNPJ">
              </b-form-input>
            </b-form-group>
          </b-col>
          <b-col sm="4">
            <b-form-group>
              <b-form-group label="Categoria">
                <b-form-select class="mb-3" v-model="filtros.categoria" :options="categorias">
                  <template #first>
                    <b-form-select-option :value="null" disabled>Selecione</b-form-select-option>
                  </template>
                </b-form-select>
              </b-form-group>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col sm="8">
            <b-form-group label="Nome e CPF:">
              <b-form-input type="text" v-model="filtros.nome_cpf" placeholder="Pesquisa por nome e CPF"></b-form-input>
            </b-form-group>
          </b-col>
        </b-row>
        <b-row>
          <b-col md="2">
            <b-button @click="limpafiltro" block variant="cinza">
              <i class="fa fa-eraser"></i>
              <span>Limpar filtros</span>
            </b-button>
          </b-col>
          <b-col md="2">
            <b-button @click="pesquisar" block variant="primary">
              <i class="fa fa-search"></i>
              <span>Pesquisar</span>
            </b-button>
          </b-col>
        </b-row>
      </b-card-body>
      <b-row>
        <b-col sm="12">
          <b-container fluid>
            <span>
              <table aria-rowcount="4" id="my-table" aria-busy="false" aria-colcount="7"
                class="table table-responsive-sm table-bordered table-striped table-sm">
                <thead>
                  <tr>
                    <th scope="col">Nome da Instituição</th>
                    <th scope="col">CNPJ</th>
                    <th scope="col">Categoria</th>
                    <th scope="col">Ações</th>
                  </tr>
                </thead>
                <tbody v-if="instituicoes.data !== undefined">
                  <tr v-for="instituicao in instituicoes.data" :key="instituicao.id">
                    <td>{{instituicao.nome_instituicao}}</td>
                    <td>{{instituicao.cnpj}}</td>
                    <td>
                      <span v-if="instituicao.categoria === 'OC'">OSC</span>
                      <span v-if="instituicao.categoria === 'GE'">Governo do Estado</span>
                      <span v-if="instituicao.categoria === 'PF'">Prefeitura Municipal</span>
                    </td>
                    <td style="width: 15%">
                      <a class="btn btn-sm btn-secondary action" title="Editar Curso"
                        @click="visualizar(instituicao.id)">
                        <i class="fa fa-search"></i>
                      </a>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="action">
                    <td colspan="4">Nenhum registro de instituições</td>
                  </tr>
                </tbody>
              </table>
              <pagination v-show="instituicoes.data !== undefined" :totalPorPagina="totalPorPagina" :resource="resource"
                :filtros="filtros"></pagination>
            </span>
          </b-container>
        </b-col>
      </b-row>
    </b-card>
  </span>
</template>

<script>
import Pagination from '@/components/shared/Pagination'
import { eventType } from '@/components/shared/eventType'
import miniToastr from 'mini-toastr'
import SessionStorage from '@/services/session-storage'

miniToastr.init()

export default {
  components: {
    Pagination
  },
  created () {
    if (SessionStorage.get('tipoPerfil').replace(/['"]+/g, '') !== 'A') {
      this.$router.push('/')
    }
  },
  computed: {
    instituicoes () {
      if (this.$store.state.pagination.getList.data !== undefined) {
        if (this.$store.state.pagination.getList.data.length !== 0) {
          return this.$store.state.pagination.getList
        } else {
          return false
        }
      }
      return this.$store.state.pagination.getList
    }
  },
  data () {
    return {
      resource: 'instituicao',
      categorias: [
        { text: 'OSC', value: 'OC' },
        { text: 'Prefeitura Municipal', value: 'PF' },
        { text: 'Governo do Estado', value: 'GE' }
      ],
      filtros: {
        filter: '',
        categoria: null,
        nome_cpf: null
      }
    }
  },
  watch: {},
  methods: {
    can (permissao) {
      return this.$store.getters.validaPermissao(permissao)
    },
    pesquisar () {
      this.$store.dispatch('getRegistrosSearch', {
        resource: this.resource,
        limit: this.totalPorPagina,
        filtros: this.filtros
      })
      this.setarFiltros(this.filtros)
    },
    limpafiltro () {
      this.filtros = {
        filter: '',
        categoria: null,
        nome_cpf: null
      }
      this.pesquisar()
    },
    setarFiltros (filtros) {
      eventType.$emit('app', filtros)
    },
    visualizar (id) {
      this.$router.push('/instituicao/visualizar/' + id)
    },
    navigate (route) {
      this.$router.push(route)
    }
  }
}
</script>

<style scoped>
.action {
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/pages/site/interna/administrador/instituicao/Instituicao.vue